import links from "@/links/links";

export default {
  actions: {
    GET(id) {
      return this.get(links.USER_GET(id));
    },
    PUT(item) {
      return this.put(links.USER_PUT(item.id), item);
    },
  },
};
